<template>
  <div class="infoBox">
    <el-row>
      <el-col
        :xs="24"
        :sm="24"
        :md="11"
        :lg="6"
        :xl="8"
        v-for="item in infoData"
        :key="item.key"
        class="_col"
      >
        <span class="key">{{ item.key }}:</span>
        <template v-if="isExtra === true">
          <slot name="cosnameSlot" v-if="item.key === 'Customer Name'"></slot>
          <span class="value" v-else>{{ item.value }}</span>
        </template>
        <span class="value" v-else>{{ item.value }}</span>
      </el-col>
      <slot></slot>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'customize-form-info',
  data() {
    return {}
  },
  props: {
    infoData: {
      type: Array,
      default: () => [],
    },
    isExtra: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.infoBox {
  width: 100%;
  ._col {
    margin-bottom: 12px;
  }
  .key {
    font-size: 14px;
    margin-right: 12px;
  }
  .value {
    font-size: 14px;
  }
}
</style>
